<ng-container *ngIf="cargando; else cargado">
  <div fxLayout="column" class="p-20" fxLayoutAlign="space-between center" >
    <mat-spinner *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
    <h1>{{'CERTIFICARV3.TAB_TRADUCCION.TEX_MOD_CARG'|translate}}</h1>
  </div>
</ng-container>

<ng-template #cargado>
  <div class="message-box info" *ngIf="idiomas.length == 0">
    {{'CERTIFICARV3.TAB_TRADUCCION.TEXT_NO_ELEG_ADIC'|translate}}
  </div>
  <mat-horizontal-stepper>

    <ng-container *ngFor="let idioma of idiomas">
      <mat-step *ngIf="idioma.tipoIdioma == '0'" label="{{'NOMBREIDIOMAS.'+idioma.nombreIdioma|translate}}" state="idioma" errorMessage="{{'CERTIFICARV3.TAB_TRADUCCION.ERR_MSG_TRADU'|translate}}">

        <!-- <form *ngFor="let grupo of seccionesDemo; let idxSecc = index;" fxLayout="column" fxLayoutAlign="space-between stretch"> -->

          <!-- <table *ngFor="let pregunta of grupo.questions; index as idxPreg;" fxLayout="column" fxLayoutAlign="space-between stretch" class="mat-card mat-elevation-z4 p-24 mt-12 mb-12"> -->
          <table *ngFor="let grupo of seccionesDemo; let idxSecc = index;" fxLayout="column" fxLayoutAlign="space-between stretch" class="mat-card mat-elevation-z4 p-24 mt-12 mb-12">
            <tr fxLayout="row">
              <th fxFlex="50" class="accent-500 p-20">{{'CERTIFICARV3.TAB_TRADUCCION.TEX_IDIO_PRIN'|translate}}</th>
              <th fxFlex="50" class="accent-100 p-20">{{'NOMBREIDIOMAS.'+idioma.nombreIdioma | translate}}</th>
            </tr>
            <!--- NOMBRE DEL GRUPO --->
            <ng-container *ngFor="let practica of grupo.questions; index as idxPreg; last as last;">
              <ng-container *ngIf="idxPreg % 2 == 0">
                <!--- TEXTO DE LA PRACTICA --->
                <tr fxLayout="row" fxLayoutAlign="space-between stretch">
                  <td fxFlex="50" fxLayout="column" fxLayoutAlign="stretch">
                    <mat-form-field appearance="outline">
                      <mat-label class="labelNative">{{'CERTIFICARV3.TAB_TRADUCCION.INGR_TEX_PRAC_4ALL'|translate}}</mat-label>
                      <ng-container *ngFor="let langPreg of practica.questionLanguage; let idxLang = index;">
                        <ng-container *ngIf="langPreg.lang == idiomaNative">
                          <textarea matInput class="textoNative" [(ngModel)]="langPreg.practice4all" [ngModelOptions]="{standalone: true}" [disabled]="true"></textarea>
                        </ng-container>
                      </ng-container>
                    </mat-form-field>
                  </td>
                  <td fxFlex="50" fxLayout="column" fxLayoutAlign="stretch">
                    <mat-form-field appearance="outline">
                      <mat-label>{{'CERTIFICARV3.TAB_TRADUCCION.INGR_TEX_TRADU_PRAC_4ALL'|translate}}</mat-label>
                      <ng-container *ngFor="let langPreg of practica.questionLanguage; let idxLang = index;">
                        <ng-container *ngIf="langPreg.lang == idioma.nombreIdioma">
                          <textarea matInput required [(ngModel)]="langPreg.practice4all" (blur)="guardaTraduccionForall($event, langPreg, idxSecc, idxPreg, idxLang, 1,1)" [ngModelOptions]="{standalone: true}" [disabled]="pasoCompleto"></textarea>
                        </ng-container>
                      </ng-container>
                      <mat-error>{{'CERTIFICARV3.TAB_TRADUCCION.TEX_NO_TRAD_TEXT'|translate}}</mat-error>
                    </mat-form-field>
                  </td>
                </tr>
                <!--- TEXTO DE LA DESCRIPCION --->
                <tr fxLayout="row" fxLayoutAlign="space-between stretch">
                  <td fxFlex="50" fxLayout="column" fxLayoutAlign="stretch">
                    <mat-form-field appearance="outline">
                      <mat-label class="labelNative">{{'CERTIFICARV3.TAB_TRADUCCION.INGR_TEX_DESCR_4ALL'|translate}}</mat-label>
                      <ng-container *ngFor="let langPreg of practica.questionLanguage; let idxLang = index;">
                        <ng-container *ngIf="langPreg.lang == idiomaNative">
                          <textarea matInput class="textoNative" [(ngModel)]="langPreg.description4all" [ngModelOptions]="{standalone: true}" [disabled]="true"></textarea>
                        </ng-container>
                      </ng-container>
                    </mat-form-field>
                  </td>
                  <td fxFlex="50" fxLayout="column" fxLayoutAlign="stretch">
                    <mat-form-field appearance="outline">
                      <mat-label>{{'CERTIFICARV3.TAB_TRADUCCION.INGR_TEX_TRADU_DESCR_4ALL'|translate}}</mat-label>
                      <ng-container *ngFor="let langPreg of practica.questionLanguage; let idxLang = index;">
                        <ng-container *ngIf="langPreg.lang == idioma.nombreIdioma">
                          <textarea matInput required [(ngModel)]="langPreg.description4all" (blur)="guardaTraduccionForall($event, langPreg, idxSecc, idxPreg, idxLang, 2,2)" [ngModelOptions]="{standalone: true}" [disabled]="pasoCompleto"></textarea>
                        </ng-container>
                      </ng-container>
                      <mat-error>{{'CERTIFICARV3.TAB_TRADUCCION.TEX_NO_TRAD_TEXT'|translate}}</mat-error>
                    </mat-form-field>
                  </td>
                </tr>
                <!--- AUDIOS --->
                <ng-container *ngIf="grupo.questions[idxPreg + 1] != undefined && (configTemplate.audios == true && configTemplate.audiosGlobal == true)">
                  <tr fxLayout="row" fxLayoutAlign="space-between stretch">
                    <td fxFlex="50" fxLayout="column" fxLayoutAlign="stretch">
                      <ng-container *ngFor="let langPreg of practica.questionLanguage; let idxLang = index;">
                        <ng-container *ngIf="langPreg.lang == idiomaNative">
                          <ng-container *ngIf="langPreg.audio == true">
                            <p><em>Pista de audio del statement 1</em></p>
                            <div fxLayout="row">
                              <button mat-mini-fab matTooltip="Reproducir audio" (click)="DEMO_reproducirAudioPregunta(langPreg)" *ngIf="langPreg.audioUrl.length == 0">
                                <mat-icon>play_arrow</mat-icon>
                              </button>
                              <audio controls *ngIf="langPreg.audioUrl.length > 0" fxFlex class="mr-20 w100">
                                <source [src]="sanitizer.bypassSecurityTrustResourceUrl(langPreg.audioUrl)" type="audio/mpeg">
                                Your browser does not support the audio element.
                              </audio>
                            </div>
                          </ng-container>
                        </ng-container>
                      </ng-container>
                    </td>
                    <td fxFlex="50" fxLayout="column" fxLayoutAlign="stretch">
                      <ng-container *ngFor="let langPreg of practica.questionLanguage; let idxLang = index;">
                        <ng-container *ngIf="langPreg.lang == idioma.nombreIdioma">
                          <ng-container *ngIf="langPreg.practice4all != ''">
                            <div fxLayout="row" fxLayoutAlign="end center" *ngIf="langPreg.audio == false">
                              <em>{{'CERTIFICARV3.MODAL_AUDIO.PREVIOS.SIN_AUDIO_FORALL' | translate}}</em>
                              <button mat-mini-fab color="primary" class="ml-20" matTooltip="Reemplazar audio" (click)="DEMO_agregarAudioPregunta(langPreg, 'ADD')">
                                <mat-icon>add</mat-icon>
                              </button>
                            </div>
                            <ng-container *ngIf="langPreg.audio == true">
                              <p><em>{{'CERTIFICARV3.MODAL_AUDIO.PREVIOS.AUDIO_STATEMENT_1' | translate}}</em></p>
                              <div fxLayout="row">
                                <button mat-mini-fab matTooltip="{{'CERTIFICARV3.MODAL_AUDIO.PREVIOS.PLAY' | translate}}" (click)="DEMO_reproducirAudioPregunta(langPreg)" *ngIf="langPreg.audioUrl.length == 0">
                                  <mat-icon>play_arrow</mat-icon>
                                </button>
                                <audio controls *ngIf="langPreg.audioUrl.length > 0" class="w100">
                                  <source [src]="sanitizer.bypassSecurityTrustResourceUrl(langPreg.audioUrl)" type="audio/mpeg">
                                  Your browser does not support the audio element.
                                </audio>
                                <button mat-mini-fab color="accent" class="ml-20" matTooltip="{{'CERTIFICARV3.MODAL_AUDIO.PREVIOS.CHANGE' | translate}}" (click)="DEMO_agregarAudioPregunta(langPreg, 'CHANGE')">
                                  <mat-icon>import_export</mat-icon>
                                </button>
                                <button mat-mini-fab color="primary" class="ml-20" matTooltip="{{'CERTIFICARV3.MODAL_AUDIO.PREVIOS.DELETE' | translate}}" (click)="DEMO_borrarAudioPregunta(langPreg)">
                                  <mat-icon>close</mat-icon>
                                </button>
                              </div>
                            </ng-container>
                          </ng-container>
                        </ng-container>
                      </ng-container>
                    </td>
                  </tr>
                </ng-container>
              </ng-container>
              <ng-container *ngIf="idxPreg % 2 != 0">
                <!--- AUDIOS --->
                <ng-container *ngIf="grupo.questions[idxPreg + 1] != undefined && (configTemplate.audios == true && configTemplate.audiosGlobal == true)">
                  <tr fxLayout="row" fxLayoutAlign="space-between stretch">
                    <td fxFlex="50" fxLayout="column" fxLayoutAlign="stretch">
                      <ng-container *ngFor="let langPreg of practica.questionLanguage; let idxLang = index;">
                        <ng-container *ngIf="langPreg.lang == idiomaNative">
                          <ng-container *ngIf="langPreg.audio == true">
                            <p><em>{{'CERTIFICARV3.MODAL_AUDIO.PREVIOS.AUDIO_STATEMENT_2' | translate}}</em></p>
                            <div fxLayout="row">
                              <button mat-mini-fab matTooltip="{{'CERTIFICARV3.MODAL_AUDIO.PREVIOS.PLAY' | translate}}" (click)="DEMO_reproducirAudioPregunta(langPreg)" *ngIf="langPreg.audioUrl.length == 0">
                                <mat-icon>play_arrow</mat-icon>
                              </button>
                              <audio controls *ngIf="langPreg.audioUrl.length > 0" fxFlex class="mr-20 w100">
                                <source [src]="sanitizer.bypassSecurityTrustResourceUrl(langPreg.audioUrl)" type="audio/mpeg">
                                Your browser does not support the audio element.
                              </audio>
                            </div>
                          </ng-container>
                        </ng-container>
                      </ng-container>
                    </td>
                    <td fxFlex="50" fxLayout="column" fxLayoutAlign="stretch">
                      <ng-container *ngFor="let langPreg of practica.questionLanguage; let idxLang = index;">
                        <ng-container *ngIf="langPreg.lang == idioma.nombreIdioma">
                          <ng-container *ngIf="langPreg.practice4all != ''">
                            <div fxLayout="row" fxLayoutAlign="end center" *ngIf="langPreg.audio == false">
                              <em>{{'CERTIFICARV3.MODAL_AUDIO.PREVIOS.SIN_AUDIO_FORALL' | translate}}</em>
                              <button mat-mini-fab color="primary" class="ml-20" matTooltip="{{'CERTIFICARV3.MODAL_AUDIO.PREVIOS.ADD_AUDIO' | translate}}" (click)="DEMO_agregarAudioPregunta(langPreg, 'ADD')">
                                <mat-icon>add</mat-icon>
                              </button>
                            </div>
                            <ng-container *ngIf="langPreg.audio == true">
                              <p><em>{{'CERTIFICARV3.MODAL_AUDIO.PREVIOS.AUDIO_STATEMENT_2' | translate}}</em></p>
                              <div fxLayout="row">
                                <button mat-mini-fab matTooltip="{{'CERTIFICARV3.MODAL_AUDIO.PREVIOS.PLAY' | translate}}" (click)="DEMO_reproducirAudioPregunta(langPreg)" *ngIf="langPreg.audioUrl.length == 0">
                                  <mat-icon>play_arrow</mat-icon>
                                </button>
                                <audio controls *ngIf="langPreg.audioUrl.length > 0" class="w100">
                                  <source [src]="sanitizer.bypassSecurityTrustResourceUrl(langPreg.audioUrl)" type="audio/mpeg">
                                  Your browser does not support the audio element.
                                </audio>
                                <button mat-mini-fab color="accent" class="ml-20" matTooltip="{{'CERTIFICARV3.MODAL_AUDIO.PREVIOS.CHANGE' | translate}}" (click)="DEMO_agregarAudioPregunta(langPreg, 'CHANGE')">
                                  <mat-icon>import_export</mat-icon>
                                </button>
                                <button mat-mini-fab color="primary" class="ml-20" matTooltip="{{'CERTIFICARV3.MODAL_AUDIO.PREVIOS.DELETE' | translate}}" (click)="DEMO_borrarAudioPregunta(langPreg)">
                                  <mat-icon>close</mat-icon>
                                </button>
                              </div>
                            </ng-container>
                          </ng-container>
                        </ng-container>
                      </ng-container>
                    </td>
                  </tr>
                </ng-container>
              </ng-container>
              <tr *ngIf="!last">
                <td colspan="2"  fxLayout="column" fxLayoutAlign="stretch">
                  <mat-divider class="p-10"></mat-divider>
                </td>
              </tr>
            </ng-container>
          </table>
        <!-- </form> -->

      </mat-step>
    </ng-container>

    <ng-template matStepperIcon="idioma">
      <mat-icon>language</mat-icon>
    </ng-template>
  </mat-horizontal-stepper>
</ng-template>
